import { render, staticRenderFns } from "./InstagramStories.vue?vue&type=template&id=ae75454e&"
import script from "./InstagramStories.vue?vue&type=script&lang=js&"
export * from "./InstagramStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports